import { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Calendar } from 'primereact/calendar';
import classNames from 'classnames';
import { ColumnFilterElementTemplateOptions } from 'primereact/column';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Nullable } from 'primereact/ts-helpers';

import styles from './InputDateFilter.module.scss';

type InputDateFilterProps = {
  className?: string;
  options?: ColumnFilterElementTemplateOptions;
  displayMenu?: boolean;
};

const InputDateFilter: FC<InputDateFilterProps> = ({
  className,
  options,
  displayMenu,
}) => {
  const [value, setValue] = useState<Nullable<Date>>();
  const calendarRef = useRef<Calendar>(null);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (options?.value) {
      setValue(options.value);
    }
  }, [options]);
  return (
    <div className={classNames(styles.dateField, className)}>
      <Calendar
        onChange={(e) => {
          setValue(e.value);
          const callback = options?.filterApplyCallback;
          if (callback) {
            callback(e.value, options?.index);
          }
          if (calendarRef.current) {
            calendarRef.current.hide();
          }
        }}
        className={styles.input}
        showIcon
        dateFormat="dd/mm/yy"
        value={value}
        mask="99/99/9999"
        hideOnDateTimeSelect
        selectOtherMonths
        locale={i18n.language}
      />
      {options?.value && !displayMenu && (
        <button
          type="button"
          onClick={() => {
            if (options && displayMenu) {
              options.filterCallback(null, options.index);
            }
            if (options && !displayMenu) {
              options.filterApplyCallback(null, options.index);
            }
          }}
          className={classNames(
            styles.clearButton,
            styles.clearButtonClassname
          )}
          aria-label="Clear date"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      )}
    </div>
  );
};

export default InputDateFilter;
